import { ActionHandler } from 'action-handler';
import { App } from './App';
import { ProductInterface } from './Model/Product';
import { ServiceLocator } from './ServiceLocator';

interface UiState {
    showExtraColumns: boolean
}

export interface AppState<M> {
    models: M[],
    ui: UiState
}

export class MainHandler<M extends ProductInterface> extends ActionHandler<App<M>, AppState<M>> {
    // @ts-ignore
    private readonly _serviceLocator: ServiceLocator;

    constructor(serviceLocator: ServiceLocator) {
        super();
        this._serviceLocator = serviceLocator;
    }

    public getInitialState(): AppState<M> {
        return {models: [], ui: {showExtraColumns: false}};
    }

    public setShowExtraColumns(flag: boolean) {
        this.setState((prevState: Readonly<AppState<M>>) => {
            const ui = Object.assign({}, prevState.ui);
            ui.showExtraColumns = flag;

            return {ui};
        });
    }

    public get showExtraColumns(): boolean {
        return this.state.ui.showExtraColumns;
    }
}
